var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-input" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.value.e164Formated,
          expression: "value.e164Formated"
        }
      ],
      staticClass: "e164Number h-4 br b-1",
      attrs: { type: "tel", name: "corp_tel" },
      domProps: { value: _vm.value.e164Formated },
      on: {
        blur: _vm.formatNumber,
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.$set(_vm.value, "e164Formated", $event.target.value)
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }